import { api } from '@/core/helpers/axiosHelper';
import { NOTIFICATION_ENDPOINTS } from './notification.endpoints';

export default {
   async getPreview({
      medium_type,
      shift_ids,
      candidate_pool_id,
      slot_state_key,
      message,
      type,
      pool_id,
      board_id,
   }: {
      medium_type: string;
      shift_ids: number[];
      candidate_pool_id: number;
      slot_state_key: string;
      message: string;
      type: string;
      pool_id?: number | string;
      board_id?: number | string;
   }) {
      const endpoint = board_id
         ? NOTIFICATION_ENDPOINTS.GET_BOARD_PREVIEW(board_id)
         : NOTIFICATION_ENDPOINTS.GET_POOL_PREVIEW(pool_id!);

      return await api
         .get(endpoint, {
            params: {
               medium_type,
               shift_ids,
               candidate_pool_id,
               slot_state_key,
               message,
               type,
            },
         })
         .catch(() => ({}))
         .then((response) => {
            return response?.data;
         });
   },
};
